var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5V8.5L9.5 10",
    stroke: "#002A69",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31813 12.1213H4.43945V10",
    stroke: "#002A69",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.43C8 13.7448 8.25579 14.0028 8.56918 13.973C9.75266 13.8602 10.8808 13.3977 11.8064 12.6381C12.8794 11.7574 13.6139 10.532 13.8847 9.17054C14.1555 7.80908 13.9459 6.39584 13.2915 5.17162C12.6372 3.9474 11.5786 2.98794 10.2961 2.45672C9.01363 1.92551 7.58665 1.8554 6.25829 2.25836C4.92993 2.66131 3.78239 3.51239 3.01118 4.66658C2.23998 5.82077 1.89283 7.20666 2.02889 8.5881C2.14626 9.77974 2.6169 10.9045 3.37402 11.821C3.5745 12.0638 3.93781 12.0622 4.16041 11.8396C4.38301 11.617 4.37994 11.2579 4.18492 11.0108C3.61149 10.2842 3.2549 9.40538 3.1634 8.47636C3.05319 7.35739 3.33438 6.23482 3.95906 5.29993C4.58373 4.36504 5.51325 3.67566 6.58922 3.34927C7.66519 3.02288 8.82104 3.07966 9.85984 3.50995C10.8986 3.94023 11.7561 4.71739 12.2861 5.70901C12.8162 6.70063 12.986 7.84536 12.7666 8.94814C12.5473 10.0509 11.9523 11.0435 11.0832 11.7568C10.3615 12.349 9.48798 12.7183 8.56872 12.8266C8.25608 12.8635 8 13.1152 8 13.43Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.2ffd3680842a6b9d6c7cb768d7002c2a.svg";
export { ForwardRef as ReactComponent };